import { Plan } from '@/types/plans';
import { getRequest, postRequest } from '@/api/amplify/helpers';

export enum AccountPackageApp {
  app = 'app',
  studio = 'studio',
}

export const fetchPlans = async ({
  appKey,
}: {
  appKey: string;
}): Promise<{
  packages: Plan[];
  appAccountPackage: {
    packageId: string;
    subscriptionCredits?: number;
    extraCredits?: number;
    app: AccountPackageApp;
  };
  creditsRefreshedAt?: string;
}> => {
  const plan = await getRequest({
    apiName: 'payment',
    path: `/${appKey}/plan`,
    options: {
      queryParams: {
        tolstoyApp: 'studio',
      },
    },
  });
  return plan;
};

export const updatePackage = async ({
  appKey,
  packageId,
}: {
  appKey: string;
  packageId: string;
}): Promise<{ link: string }> => {
  return postRequest({
    apiName: 'accountActions',
    path: '/actions/accounts/update-package',
    options: {
      body: {
        appKey,
        packageId,
        tolstoyApp: 'studio',
      },
    },
  });
};

export const unsubscribe = async ({ appKey }: { appKey: string }) => {
  await postRequest({
    apiName: 'payment',
    path: '/unsubscribe',
    options: {
      body: {
        appKey,
        tolstoyApp: 'studio',
      },
    },
  });
};
